import { navigate } from 'gatsby'
import {
  PageHeader as BasePageHeader,
  PageHeaderProps as BasePageHeaderProps,
} from 'antd'
import { Icon } from 'components/common'
import { Button } from '../button'

export interface PageHeaderProps extends Omit<BasePageHeaderProps, 'extra'> {
  iconSize?: number
  // 前ページヘのパス
  prevPage?: string
  // 次ページへのパス
  nextPage?: string
}

export const PageHeader = ({
  iconSize,
  prevPage,
  nextPage,
  ...rest
}: PageHeaderProps): JSX.Element => {
  const extra = []
  if (prevPage) {
    extra.push(
      <Button icon={<Icon.LeftOutlined />} onClick={() => navigate(prevPage)} />
    )
  }

  if (nextPage) {
    extra.push(
      <Button
        icon={<Icon.RightOutlined />}
        onClick={() => navigate(nextPage)}
      />
    )
  }

  return (
    <>
      <BasePageHeader {...rest} extra={extra} />
    </>
  )
}
